import { Mail, X, RotateCcw } from "lucide-react";
import type { Invitee } from "./types";

interface PendingInviteCardProps {
  invite: Invitee;
  onCancel: () => void;
  onResend: () => void;
}

export function PendingInviteCard({
  invite,
  onCancel,
  onResend,
}: PendingInviteCardProps) {
  return (
    <div className="flex items-center justify-between rounded-lg border border-dashed border-amber-300 bg-amber-50 p-3">
      <div className="flex items-center gap-3 min-w-0">
        <div className="h-10 w-10 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
          <Mail className="h-5 w-5 text-amber-600" />
        </div>
        <div className="min-w-0">
          <div className="text-sm font-medium text-amber-900">
            Invitation envoyée à :
          </div>
          <div className="text-sm text-amber-700 truncate">{invite.email}</div>
          {invite.name && (
            <div className="text-xs text-amber-600 truncate">
              Nom: {invite.name}
            </div>
          )}
        </div>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <button
          type="button"
          onClick={onResend}
          className="text-amber-600 hover:text-amber-800 p-1 rounded-md hover:bg-amber-200"
          title="Renvoyer l'invitation"
        >
          <RotateCcw className="h-4 w-4" />
        </button>
        <button
          type="button"
          onClick={onCancel}
          className="text-amber-600 hover:text-amber-800 p-1 rounded-md hover:bg-amber-200"
          title="Annuler l'invitation"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
